import React from "react";
import Drawer from "components/ui-component/SideDrawer";
import PreviewDocuments from "./PreviewDocuments";
import { DocumentAttachment } from "types/Documents";
import { DRAWER_MOBILE_SIZE, DRAWER_DESKTOP_SIZE } from "constants/documents";
import { ToastState } from "types/common";
import { useTestAttrsFactory } from "utils/testid";

interface PreviewDrawerProps {
  isOpen: boolean;
  data: DocumentAttachment | null;
  previewId: string;
  isMobile: boolean;
  onClose: () => void;
  onDataChange: (data: DocumentAttachment | null) => void;
  onIdChange: (id: string) => void;
  onToastMessage: (msg: ToastState) => void;
}

const PreviewDrawer: React.FC<PreviewDrawerProps> = ({
  isOpen,
  data,
  previewId,
  isMobile,
  onClose,
  onDataChange,
  onIdChange,
  onToastMessage,
}) => {
  const testAttrs = useTestAttrsFactory();
  const handleClose = () => {
    // clear any preview-origin toast
    onToastMessage({
      variant: "",
      content: "",
      isFromPreview: false,
    });

    // also clear preview data/id
    onDataChange?.(null);
    onIdChange?.(null as any);

    onClose();
  };
  return (
    <Drawer
      enableOverlay={true}
      lockBackgroundScroll={true}
      direction="right"
      open={isOpen}
      size={isMobile ? DRAWER_MOBILE_SIZE : DRAWER_DESKTOP_SIZE}
      onClose={handleClose}
      overlayColor="#000"
    >
      <div
        className="contents"
        {...testAttrs("preview-drawer", "Document preview drawer")}
      >
        <PreviewDocuments
          show={isOpen}
          data={data}
          setData={onDataChange}
          setShow={handleClose}
          setMsg={onToastMessage}
          isPreviewId={previewId}
          setIsPreviewId={onIdChange}
        />
      </div>
    </Drawer>
  );
};

export default PreviewDrawer;
